module.exports = __webpack_public_path__ + "static/img/filter.e7ed976.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DOM/EffectFilter/img/filter.png
// module id = 471
// module chunks = 0